/**
 * import react
 */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

/**
 * import AppActions
 */
import AppActions from '../../../actions/app-actions';

/**
 * import material-ui
 */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Tabel from '@material-ui/core/Table';
import TabelHead from '@material-ui/core/TableHead';
import TabelBody from '@material-ui/core/TableBody';

/**
 * import components
 */
import DeviceTsdbTabelHead from './device-tsdb-tabel-head';
import DeviceTsdbTabelBody from './device-tsdb-tabel-body';

/**
 * import helper
 */
import { defaultTableData } from './helper';

const DeviceTsdbInfoDlg = (props) => {
  const [fetched, setFetched] = useState(false);
  const [data, setData] = useState(defaultTableData())

  useEffect(() => {
    AppActions.getTsdbDataInfo(props)
      .then((data) => {
        const {results=[]} = data || {};
        const {series=[]} = (results.length && results[0]) || [];
        const obj = (series.length && series[0]) || defaultTableData();
        setData(() => (obj));
        setFetched(() => true);
      })
      .catch(() => {
        setData(() => defaultTableData());
        setFetched(() => true);
      });
  }, []);

  const actionList = () => {
    return (
      <>
        <Button onClick={props.handleClose}>Close</Button>
      </>
    );
  };

  const content = () => {
    if (fetched) {
      if (data.columns.length) {
        const timeIndex = data.columns.findIndex(c => c === 'time');
        return (
          <Tabel stickyHeader>
            <TabelHead>
              <DeviceTsdbTabelHead columns={data.columns}/>
            </TabelHead>
            <TabelBody>
              <DeviceTsdbTabelBody values={data.values} timeIndex={timeIndex} />
            </TabelBody>
          </Tabel>
        );
      } else {
        return (
          <Typography align='center'>Record not found</Typography>
        );
      }
    } else {
      return (
        <Typography align='center'>Please wait fetching in-progress</Typography>
      )
    }
  };

  return (
    <Dialog open={true} maxWidth='lg' style={{ overflowY: 'unset' }}>
      <DialogTitle>{props.txt}</DialogTitle>
      <DialogContent style={{ overflowY: 'auto', paddingTop: 0 }}>
        {content()}
      </DialogContent>
      <DialogActions>
        {actionList()}
      </DialogActions>
    </Dialog>
  );
};

DeviceTsdbInfoDlg.propTypes = {
  open: PropTypes.bool.isRequired,
  txt: PropTypes.string.isRequired,
  db: PropTypes.string.isRequired,
  measurement: PropTypes.string.isRequired,
  deviceId: PropTypes.string.isRequired,
  time: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default DeviceTsdbInfoDlg;
